var map = {
	"./aquarium.png": "b974",
	"./fugu.png": "8177",
	"./fugu_2.png": "282c",
	"./jinbei.png": "4949",
	"./jinbei_2.png": "5b4a",
	"./kame.png": "9cc0",
	"./kame_2.png": "3209",
	"./kozakana.png": "f2cb",
	"./kozakana_2.png": "a0a1",
	"./kumanomi.png": "dc14",
	"./kumanomi_2.png": "9f70",
	"./kurage.png": "c688",
	"./kurage_2.png": "97e9",
	"./kurione.png": "b610",
	"./kurione_2.png": "3ea9",
	"./manbou.png": "3675",
	"./manbou_2.png": "593c",
	"./oct.png": "457b",
	"./oct_2.png": "9403",
	"./saba.png": "49ec",
	"./saba_2.png": "aa4a",
	"./tako.png": "6229",
	"./takoW.png": "fe0d",
	"./takoW_2.png": "f0a8",
	"./tako_2.png": "8362"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9979";